export default __webpack_public_path__ + "static/media/Calendar.d88ce234.svg";